import React from 'react'
import mainLogo from '../../assets/images/Justivide-PrimaryIcon.svg'

const PageLoader = () => {
    return (
        <div className='page-loader'>
            <img className='page-loader-logo' src={mainLogo} alt="" />
        </div>
    )
}

export default PageLoader